export enum TimeInterval {
    Week = 'week',
    Month = 'month',
    Year = 'year',
}
